<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Send Mail</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                    <v-col md="12" cols="12">
                                        <v-card class="pa-4" elevation="3" rounded="lg">
                                            <!-- Header -->
                                            <div class="d-flex align-center mb-4">
                                                <h2 class="text-h6 font-weight-bold">New Message</h2>
                                            </div>

                                            <!-- TO -->
                                            <v-text-field
                                                label="To"
                                                variant="outlined"
                                                density="comfortable"
                                                bg-color="grey-lighten-4"
                                                v-model="form.to"
                                                clearable
                                                class="mb-2"
                                            />

                                            <!-- CC / BCC toggles -->
                                            <div class="d-flex gap-3 mb-1">
                                                <v-btn size="small" variant="text" @click="showCc = !showCc">Cc</v-btn>
                                                <v-btn size="small" variant="text" @click="showBcc = !showBcc">Bcc</v-btn>
                                            </div>

                                            <!-- CC -->
                                            <v-text-field
                                                v-if="showCc"
                                                label="Cc"
                                                variant="outlined"
                                                density="comfortable"
                                                bg-color="grey-lighten-4"
                                                v-model="form.cc"
                                                clearable
                                                class="mb-2"
                                            />

                                            <!-- BCC -->
                                            <v-text-field
                                                v-if="showBcc"
                                                label="Bcc"
                                                variant="outlined"
                                                density="comfortable"
                                                bg-color="grey-lighten-4"
                                                v-model="form.bcc"
                                                clearable
                                                class="mb-2"
                                            />

                                            <!-- SUBJECT -->
                                            <v-text-field
                                                label="Subject"
                                                variant="outlined"
                                                density="comfortable"
                                                bg-color="grey-lighten-4"
                                                v-model="form.subject"
                                                class="mb-4"
                                            />

                                            <!-- MESSAGE BODY -->
                                            <v-textarea
                                                label="Message"
                                                variant="outlined"
                                                density="comfortable"
                                                auto-grow
                                                bg-color="grey-lighten-4"
                                                rows="8"
                                                v-model="form.body"
                                            />

                                            <!-- ATTACHMENT BUTTON -->
                                            <div class="d-flex align-center mt-4">
                                            <v-btn
                                                prepend-icon="mdi-paperclip"
                                                variant="text"
                                                @click="pickFile"
                                            >
                                                Attach File
                                            </v-btn>

                                            <input
                                                type="file"
                                                ref="fileInput"
                                                hidden
                                                @change="handleFile"
                                            />
                                            </div>

                                            <!-- SHOW SELECTED FILES -->
                                            <div v-if="attachments.length" class="mt-2">
                                            <v-chip
                                                v-for="(file, index) in attachments"
                                                :key="index"
                                                class="ma-1"
                                                closable
                                                @click:close="removeAttachment(index)"
                                            >
                                                {{ file.name }}
                                            </v-chip>
                                            </div>

                                            <!-- SEND BUTTON -->
                                            <div class="d-flex justify-end mt-6">
                                            <v-btn
                                                color="primary"
                                                prepend-icon="mdi-send"
                                                class="px-6"
                                                @click="sendMail"
                                            >
                                                Send
                                            </v-btn>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    </v-row>                             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { useRouter } from "vue-router";

export default {
        components: {
            
        },

        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
        }),

        watch: {

        },

        created() {
            
        },

        computed:{
            getSchema() {

            },
        },

        methods: {

        },

        mounted() {

        },

        setup() {
            const showCc = ref(false);
            const showBcc = ref(false);
            const attachments = ref([]);

            const fileInput = ref(null);

            const form = ref({
                to: "",
                cc: "",
                bcc: "",
                subject: "",
                body: ""
            });

            const pickFile = () => {
                fileInput.value.click();
            };

            const handleFile = (event) => {
                const file = event.target.files[0];
                if (file) attachments.value.push(file);
            };

            const removeAttachment = (index) => {
                attachments.value.splice(index, 1);
            };

            const sendMail = () => {
                // Here you will call your API
                console.log("Sending mail...", form.value, attachments.value);
            };

            return {
                showCc,
                showBcc,
                attachments,
                fileInput,
                form,
                pickFile,
                handleFile,
                removeAttachment,
                sendMail
            }
        }
    }
</script>